let API_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "" // In dev, requests go through the CRA proxy (see setupProxy.js)
    : "https://fb.dataklout.com"; // Production fallback

let configReady = process.env.NODE_ENV === "development";
let configPromise = null;

export const initializeConfig = async () => {
  // In development, skip config.json so requests go through the CRA proxy
  if (process.env.NODE_ENV === "development") {
    configReady = true;
    return API_BASE_URL;
  }

  if (configPromise) return configPromise;

  configPromise = (async () => {
    try {
      const response = await fetch("/config.json", { cache: "no-cache" });
      const data = await response.json();
      if (data.API_BASE_URL) {
        API_BASE_URL = data.API_BASE_URL;
      }
    } catch (error) {
      console.error("Failed to load config, using default:", error);
    } finally {
      configReady = true;
    }
    return API_BASE_URL;
  })();

  return configPromise;
};

/** Resolves when config.json has been applied (or skipped in dev). */
export const whenConfigReady = () => {
  if (configReady) return Promise.resolve(API_BASE_URL);
  return initializeConfig();
};

const config = {
  get API_BASE_URL() {
    return API_BASE_URL;
  },
  get isReady() {
    return configReady;
  },
};

export default config;
